import { refreshAccessToken, setTokens } from './tokenHandler';

export const logout = () => {
  cleanLocalStorage()
  window.location.reload(false);
}

const cleanLocalStorage = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('currentUserVersion');
  localStorage.removeItem('puzzelToken');
}

export const makeLoginRequest = async (username, password) => {
  let formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);

  try {
    const response = await fetch('/login', {
      method: 'post',
      body: formData
    });

    switch(response.status) {
      case 200:
        const tokens = await response.json();

        // window.location.reload(); // do not reload here.. it breaks next validation

        // validate access
        const puzzeltoken = tokens.puzzelToken
        // console.log(`puzzel token ${puzzeltoken}`)

        const is_valid = await getUserConfigRequest(puzzeltoken)
            .then(data => {

              console.log(data)

              // let config = JSON.parse(data)
              let config = data

              if (!config.user || config.user === "" || config.user === "null" )
                return false

              if (config.roles.includes('ADMIN') || config.roles.includes('admin')){
                console.log("admin user")
                return true
              }
              else 
              {
                console.log("not admin user")
                return false
              }
            })
            .catch((error) => { 
              console.log(error.message) 
              return false
            })


        if (is_valid){
          setTokens(tokens)
          return { status: 200 };
        }
        else{
          cleanLocalStorage()
          return { status: 500, error: 'Något gick fel vid inloggning' };
        }

      case 401:
        cleanLocalStorage()
        return { status: 401, error: 'Fel användarnamn eller lösenord' };
      default:
        cleanLocalStorage()
        return { status: 500, error: 'Något gick fel vid inloggning' };
    }
  } catch(err) {
    cleanLocalStorage()
    return { status: 500, error: 'Något gick fel vid inloggning' };
  }
}


export const getUserConfigRequest = async (puzzelToken) => {

  return fetch(`/configuration/${puzzelToken}`,  
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
      }
    ).then((response) => {
      if(response.ok){
        return response.json()
      }else
      throw new Error(`HTTPStatusCode: ${response.status}. Message: ${response.statusText}`)
    })
}


